export default "__VITE_ASSET__tPjPE$wu__"